import { createFileRoute } from '@tanstack/react-router';

/**
 * Event Alerts Details Route Definition
 * Component is loaded from route.lazy.tsx for automatic code splitting
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/event_alerts_details/$muns/$subscription_ids')({
  // No beforeLoad - parent _protected handles auth
});
